import KnockoutExtensions from 'app/KnockoutExtensions';

// Knockout mapping configuration passed to ko.mapping.fromJS to wrap nullable
// child objects. Lives here (rather than in constants.ts) because it is coupled
// to the Knockout bridge and cannot be a pure value constant.
export const CustomerMapping = {
  'Csr': {
    create: (item: any) => {
      return KnockoutExtensions.createNullableChildObject(item);
    }
  },
  'Team': {
    create: (item: any) => {
      return KnockoutExtensions.createNullableChildObject(item);
    }
  }
};
